import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import Required from 'hb-react/shared/components/Required';

const LabelBody = ({ preventOverflow, children }) =>
  preventOverflow ? (
    <Dotdotdot tagName="span" clamp={1}>
      {children}
    </Dotdotdot>
  ) : (
    children
  );

const Label = ({
  label,
  id,
  className,
  simpleFormGemClass,
  required = false,
  withoutCSS = false,
  displayEmpty = false,
  preventOverflow = true,
}) => {
  const ukLabelClass = 'uk-form-label';
  let title = label;

  if (required) {
    title += ' *';
  }

  if (!label && !displayEmpty) {
    return null;
  }

  return (
    <label
      className={classNames(className, {
        required,
        'push-quarter--bottom inline-block': !withoutCSS,
        [ukLabelClass]: ukLabelClass && !withoutCSS,
        [simpleFormGemClass]: simpleFormGemClass && !withoutCSS,
        invisible: !label && displayEmpty,
      })}
      htmlFor={id}
      data-testid="formik-label"
      title={title}
    >
      <LabelBody preventOverflow={preventOverflow}>
        {label}
        {required && <Required />}
      </LabelBody>
    </label>
  );
};

Label.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  simpleFormGemClass: PropTypes.string,
  required: PropTypes.bool,
  withoutCSS: PropTypes.bool,
  displayEmpty: PropTypes.bool,
};

export default Label;
